// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"25564b87","218":"93d45c49","526":"6ca63b67"}[chunkId] + ".chunk.css";
};